<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><i>This book is dedicated to</i></p>
<p class="center"><i>Addie Gilbert,</i></p>
<p class="center"><i>with the deepest thanks</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?55b69207